import { Column, Entity, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IInstallation } from './interface/IInstallation';
import { IRefChapterRubric } from './interface/IRefChapterRubric';
import { IRefObservation } from './interface/IRefObservation';
import { IRefTheme } from './interface/IRefTheme';

@Entity('ref_observation')
export class RefObservation extends BaseEntity implements IRefObservation {
    apiMapping = {
        id: 'id',
        name: 'longName',
        shortname: 'shortName',
        code: 'code',
        order: 'ordre',
        priority: 'priority',
        solution: 'solution',
        isDeleted: 'isDeleted',
        refThemeId: {
            fieldName: 'refTheme',
            type: 'RefTheme',
        },
        refChapterRubricId: {
            fieldName: 'refChapterRubric',
            type: 'RefChapterRubric',
        },
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    longName: string;

    @Column({ nullable: true })
    shortName: string;

    @Column({ nullable: true })
    code: string;

    @Column({ nullable: true })
    ordre: number;

    @Column({ nullable: true })
    solution: string;

    @Column({ nullable: true })
    priority: number;

    @Column({ nullable: true })
    isDeleted: boolean;

    @Column({ nullable: true })
    local: boolean;

    @ManyToOne('Installation')
    installation: IInstallation;

    @ManyToOne('RefTheme')
    refTheme: IRefTheme;

    @ManyToOne('RefChapterRubric')
    refChapterRubric: IRefChapterRubric;
}
